import {
  BREAKFAST_MENU,
  BRUNCH_MENU,
  DESSERTS_MENU,
  DIETARY_MENU,
  DINNER_MENU,
  DRINKS_MENU,
  EVENTS_MENU,
  FESTIVE_MENU,
  KIDS_MENU,
  LUNCH_MENU,
  MAIN_MENU,
  OTHER_MENU,
  SET_MEAL_MENU,
  SPECIALS_MENU,
  STARTERS_MENU,
  TAKEAWAY_MENU,
  TIME_LIMITED_MENU,
} from '../../menus/constants'

const ALLOWED_MENU_FILE_CATEGORIES_FOR_SCRAPING = [
  MAIN_MENU,
  BREAKFAST_MENU,
  BRUNCH_MENU,
  LUNCH_MENU,
  DINNER_MENU,
  DESSERTS_MENU,
  KIDS_MENU,
  FESTIVE_MENU,
  EVENTS_MENU,
  DRINKS_MENU,
  DIETARY_MENU,
  SPECIALS_MENU,
  SET_MEAL_MENU,
  STARTERS_MENU,
  TAKEAWAY_MENU,
  TIME_LIMITED_MENU,
  OTHER_MENU,
]

const isDocumentFileEligibleForScraping = fileCategory =>
  ALLOWED_MENU_FILE_CATEGORIES_FOR_SCRAPING.includes(fileCategory)

export default isDocumentFileEligibleForScraping
